import { Person } from "../person/Person"
import { buildLandPlot, Landplot } from "./Landplot"

export type FarmerGroup = {
    plots: Landplot[]
    person: Person
}

export class GroupModel {
    id: number
    organisation_id: number
    name: string
    plots: Landplot[]
    farmers: FarmerGroup[]
    isPuclicVisible: boolean
    delta: number

    constructor(id: number, orgId: number, name: string, plots: Landplot[], isPublicVisible?: boolean, delta?: number) {
        this.id = id
        this.name = name
        this.plots = plots
        this.farmers = this.buildFarmers()
        this.isPuclicVisible = isPublicVisible
        this.delta = delta
    }

    buildFarmers(): FarmerGroup[] {
        const map = new Map<number, FarmerGroup>()
        this.plots?.forEach(p => {
            if (p?.owner) {
                const f = map.get(p?.owner?.id)
                if (f) {
                    map.set(p.owner.id, { plots: [...f.plots, p], person: p.owner })
                } else {
                    map.set(p.owner.id, { plots: [p], person: p.owner })
                }
            }
        })

        return [...map.values()]
    }

    plotsNumber() {
        return this.plots.length
    }
}


export function buildGroup(g: any) {
    return new GroupModel(g.group_id,
        g.organisation_id,
        g.group_name,
        g.plots?.map(p => buildLandPlot(p)),
        g.is_public ?? false,
        (g.group_delta_boost ?? 0) > 0 ? g.group_delta_boost : undefined)
}

export function buildGroups(g: any) {
    const groups: GroupModel[] = g?.map(group => {
        return buildGroup(group)
    })
    return groups?.sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()))
}